var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderlineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3643 8.55469H20.8245V16.1115C20.8245 16.96 20.6218 17.7024 20.2165 18.3388C19.815 18.9751 19.2525 19.4714 18.529 19.8274C17.8055 20.1797 16.9627 20.3558 16.0006 20.3558C15.0347 20.3558 14.19 20.1797 13.4665 19.8274C12.743 19.4714 12.1805 18.9751 11.779 18.3388C11.3775 17.7024 11.1768 16.96 11.1768 16.1115V8.55469H13.637V15.9013C13.637 16.3445 13.7336 16.7384 13.9268 17.0831C14.1237 17.4278 14.4002 17.6986 14.7563 17.8956C15.1124 18.0926 15.5271 18.1911 16.0006 18.1911C16.4779 18.1911 16.8927 18.0926 17.2449 17.8956C17.601 17.6986 17.8756 17.4278 18.0688 17.0831C18.2658 16.7384 18.3643 16.3445 18.3643 15.9013V8.55469Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.165 22.3555H21.8355V23.4464H10.165V22.3555Z",
    fill: "#475467"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/underline-icon.53290c1dcf4ab239e5dcd1ec6b3722fc.svg";
export { ForwardRef as ReactComponent };